import React from 'react';

export type ChangeEventHandler = React.ChangeEventHandler<HTMLInputElement>;

export const getInputValueByName = (changeEvent: any): any => {
    const target = changeEvent.currentTarget;
    let value;
    if(target.type === 'checkbox' ){
        value = target.checked;
    }
    else if(!isNaN(target.value)){
        value = Number(target.value);
    }
    else{
        value = target.value;
    }
    const name = target.name;

    return { [name]: value };
}